var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
export var PreviewAction = function (_a) {
    var children = _a.children, verticallyCentered = _a.verticallyCentered, visible = _a.visible;
    return (_jsx("button", __assign({ className: clsx("absolute flex rounded-full text-white text-center z-10 text-small bg-sorbus-default", verticallyCentered && "-mt-2", visible ? "opacity-100" : "opacity-0"), style: { width: "2rem", height: "2rem", right: 4 } }, { children: _jsx("label", __assign({ className: "m-auto" }, { children: children }), void 0) }), void 0));
};
